
import axios from '../../../config-axios'
import { ElMessage } from 'element-plus'

export default {
    namespaced: true,
    state: () => ({
        sensorList: {},
        companyList: [],
        images: {},
    }),
    getters: {
        getSensorList(state) {
            return state.sensorList
        },
        getCompanyList(state) {
            return state.companyList
        },
        getImages: state => mac => state.images[mac] || {},
        getSensorImage: (state, getters) => mac => getters.getImages(mac).Sensor?.url || null,
        getPlaceImage:  (state, getters) => mac => getters.getImages(mac).Place?.url  || null,
        getSensorImageObj: state => mac => state.images[mac]?.Sensor || null,
        getPlaceImageObj: state => mac => state.images[mac]?.Place || null,
    },
    mutations: {
        setSensorList(state, options) {
            state.sensorList = options
        },
        setSensorParam(state, options) {
            let keySen = null;
            let indexSen = null;
            for (const key of Object.keys(state.sensorList)) {
                indexSen = state.sensorList[key].sensors.findIndex(el=>el.id_sensor==options.element.id_sensor?true:false)
                if (indexSen != null && indexSen != -1) {
                keySen = key;
                break
                }
            }
            if (indexSen != null && indexSen != -1 && keySen != null) {
                if (state.sensorList[keySen].sensors[indexSen].company_id != options.element.company_id) {
                    if (options.company) {
                        if (state.sensorList[options.company.name] == undefined) {
                            state.sensorList[keySen].sensors.splice(indexSen, 1)
                            state.sensorList[options.company.name] = {
                                company_id: options.company.id,
                                show_name: options.company.showing_name,
                                sensors: [options.element],
                                counters: []
                            }
                        } else {
                            state.sensorList[keySen].sensors.splice(indexSen, 1)
                            state.sensorList[options.company.name].sensors.push(options.element)
                        }
                    } else {
                        if (state.sensorList['unregistered'] == undefined) {
                            state.sensorList[keySen].sensors.splice(indexSen, 1)
                            state.sensorList.unregistered = {
                                show_name: "Не зарегистрированные",
                                sensors: [options.element],
                                counters: []
                            }
                        } else {
                            state.sensorList[keySen].sensors.splice(indexSen, 1)
                            state.sensorList.unregistered.sensors.push(options.element)
                        }
                    }
                } else {
                    state.sensorList[keySen].sensors[indexSen] = options.element
                }
            }

        },
        setCompanyList(state, options) {
            state.companyList = options
            state.companyList.unshift({ id: 0, label: 'Не зарегистрированные' })
        },
        setLocalImage(state, { mac, type, file, url }) {
            if (!state.images[mac]) state.images[mac] = {}
            state.images[mac][type] = { file, url, fromServer: false }
        },
        removeLocalImage(state, { mac, type }) {
            if (state.images[mac]) {
                delete state.images[mac][type]
            }
        },
        setLocalImagesClean(state) {
            state.images = {}
        }
    },
    actions: {
        async chageSensorsInfo(context, options) {
          try {
            const response = await axios.patch('sensor/change_sensor', options)
          } catch (error) {
            console.log(error.response.data.text)
          }
        },
        async getSensorLastData(context, options) {
            let url = 'sensor_point/'
            if (options == true) {
                url += 'demo/'
            }
            await axios.get(url).then( response => {
                context.commit('setSensorList', response.data)
            }).catch(error=>{
                console.log(error)
                // alert('Error request') sensor_point
                ElMessage.error('Ошибка, не получилось получить данные о оборудовании')
            })
        },
        async putSensorSettings(context, options) {
            const formData = new FormData()
        
            Object.keys(options).forEach(key => {
                formData.append(key, options[key]);
            });
            await axios.put('sensor/settings/', formData, {
                headers: { "Content-Type": "multipart/form-data" },
            }).then(response=>{
                context.commit('setSensorParam', response.data)
                ElMessage.success('Параметры изменены')
        
            }).catch(error=>{
                console.log(error)
                // alert('Error request')
                ElMessage.error('Ошибка, не удалось изменить параметры')
            })
        },
        async getApiCompanyList(context) {
            await axios.get('company/').then(response => {
                context.commit('setCompanyList', response.data)
            }).catch(error=>{
                console.log(error)
                ElMessage.error('Ошибка, не удалось получить список компаний')
            })
        },
        async fetchImage({ commit }, { mac, type }) {
            try {
                const response = await axios.get(`/sensor/images/?type=${type}&mac=${mac}`, {
                responseType: 'blob',
                })
                const blob = response.data
                const url = URL.createObjectURL(blob)
                commit('setLocalImage', { mac, type, file: blob, url})
            } catch (error) {
                console.warn(`Нет изображения для ${mac}, type=${type}`)
            }
        },
        uploadImageLocal({ commit }, { mac, type, file }) {
            const url = URL.createObjectURL(file)
            commit('setLocalImage', { mac, type, file, url })
        },
        deleteImageLocal({ commit }, { mac, type }) {
            commit('removeLocalImage', { mac, type })
        },
    }

}